// extracted by mini-css-extract-plugin
export default {"itemPostPlaceholder":"_10Vn1","exchangeCardImg":"_2wQt3","exchangeWidgetAsset":"_3iUD6","exchangeCard":"_2i_Fq","hideVasTag":"_1Ye2_","smallExchangeCard":"_1h72A"};